import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Hook personalizado para Google Analytics
export const useAnalytics = () => {
  const location = useLocation();

  // Track page views automáticamente
  useEffect(() => {
    if (process.env.REACT_APP_GA_MEASUREMENT_ID && 
        process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  // Función para trackear eventos personalizados
  const trackEvent = (category, action, label = null, value = null) => {
    if (process.env.REACT_APP_GA_MEASUREMENT_ID && 
        process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
      ReactGA.event({
        category,
        action,
        label,
        value,
      });
    }
  };

  // Función para trackear eventos de usuario
  const trackUserAction = (action, details = {}) => {
    trackEvent('User Action', action, JSON.stringify(details));
  };

  // Función para trackear errores
  const trackError = (error, context = {}) => {
    trackEvent('Error', error.message || error, JSON.stringify(context));
  };

  return {
    trackEvent,
    trackUserAction,
    trackError,
  };
};

// Función para trackear login
export const trackLogin = (method = 'email') => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && 
      process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
    ReactGA.event({
      category: 'Authentication',
      action: 'Login',
      label: method,
    });
  }
};

// Función para trackear creación de registros
export const trackCreate = (type, details = {}) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && 
      process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
    ReactGA.event({
      category: 'Data',
      action: 'Create',
      label: type,
      value: 1,
    });
  }
};

// Función para trackear navegación entre vistas
export const trackNavigation = (fromView, toView) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && 
      process.env.REACT_APP_GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
    ReactGA.event({
      category: 'Navigation',
      action: 'View Change',
      label: `${fromView} → ${toView}`,
    });
  }
}; 